import React from 'react';
import { CgPhone } from 'react-icons/cg';
import { MdEmail, MdLocationOn } from 'react-icons/md';

import Button from '../inputs/Button';
import TextInput from '../inputs/Text';
import TextareaInput from '../inputs/Textarea';

function ContactUs() {
  return (
    <div className="content">
      <div className="max-w-5xl mx-auto">

        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="section-header">Get in touch</h1>
          <p className="big-p max-w-2xl mx-auto">
            We are offering immersive learning experiences that create opportunities
            for you and your team to grow and develop together.
          </p>
        </div>

        {/* Contact info cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-12">
          <div className="flex flex-col items-center text-center bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
            <div className="w-12 h-12 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mb-3">
              <CgPhone className="text-primary w-6 h-6" />
            </div>
            <p className="text-xs text-labelColor uppercase tracking-widest mb-1">Phone</p>
            <p className="font-semibold text-textColor text-sm">0913 509 8302</p>
          </div>
          <div className="flex flex-col items-center text-center bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
            <div className="w-12 h-12 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mb-3">
              <MdEmail className="text-primary w-6 h-6" />
            </div>
            <p className="text-xs text-labelColor uppercase tracking-widest mb-1">Email</p>
            <p className="font-semibold text-textColor text-sm">purpleacademy@wemabank.com</p>
          </div>
          <div className="flex flex-col items-center text-center bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
            <div className="w-12 h-12 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mb-3">
              <MdLocationOn className="text-primary w-6 h-6" />
            </div>
            <p className="text-xs text-labelColor uppercase tracking-widest mb-1">Address</p>
            <p className="font-semibold text-textColor text-sm">48, Town Planning Way, Ilupeju, Purple Academy</p>
          </div>
        </div>

        {/* Map + Form */}
        <div className="flex flex-col md:flex-row gap-8">
          {/* Map */}
          <div className="w-full md:w-1/2 rounded-2xl overflow-hidden shadow-sm border border-gray-100 min-h-[380px]">
            <iframe
              title="Wema Bank Location"
              src="https://maps.google.com/maps?q=48+Town+Planning+Way,+Ilupeju,+Lagos,+Nigeria&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '380px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* Form */}
          <div className="w-full md:w-1/2">
            <div className="bg-white rounded-2xl px-8 py-8 shadow-sm border border-gray-100 h-full">
              <h2 className="text-xl font-bold font-title mb-1">Send us a message</h2>
              <p className="text-sm text-labelColor mb-6">We&apos;ll get back to you as soon as possible.</p>
              <form>
                <TextInput placeholder="Your Name" className="mb-4" />
                <TextInput placeholder="Your Email" type="email" className="mb-4" />
                <TextInput placeholder="Subject" className="mb-4" />
                <TextareaInput placeholder="Your Message" rows={4} className="mb-5" />
                <Button className="w-full" paddingY="py-3.5" fontSize="text-sm">Send Message</Button>
              </form>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default ContactUs;
